/**
 * @generated SignedSource<<65f6070e7eea3dc63198431e660e2ae9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventFeedOrdering = "CHRONOLOGICAL" | "REVERSE" | "%future added value";
export type EventFilter = "ALL" | "LIVE" | "PAST" | "UPCOMING" | "%future added value";
export type PermissionType = "ANALYTICS_VIEWER" | "BADGE_ADMIN" | "BILLING_ADMIN" | "CLUB_ADMIN" | "COURSE_ADMIN" | "GROUP_ADMIN" | "INTEGRATION_ADMIN" | "MEMBER_ADMIN" | "MODERATOR" | "PERMISSION_ADMIN" | "PERMISSION_VIEWER" | "PINNED_LINK" | "POST_ADMIN" | "POST_PIN" | "SEGMENT_ADMIN" | "SEGMENT_VIEWER" | "SPACE_ADMIN" | "TAG_ADMIN" | "%future added value";
export type eventosQuery$variables = {
  filter: EventFilter;
  orderBy: EventFeedOrdering;
  slug: string;
};
export type eventosQuery$data = {
  readonly club: {
    readonly id: string;
    readonly leaderboard: string | null | undefined;
    readonly permissions: ReadonlyArray<{
      readonly slug: PermissionType;
    }>;
    readonly ranking: {
      readonly rankingUsers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly totalPoints: number;
          };
        }>;
      };
    };
    readonly " $fragmentSpreads": FragmentRefs<"eventosFeedFragment" | "portals_club" | "sidebarPreview">;
  };
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"portals_user">;
  } | null | undefined;
};
export type eventosQuery = {
  response: eventosQuery$data;
  variables: eventosQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Permission",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": true,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v7 = {
  "alias": "leaderboard",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "LEADERBOARD"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"LEADERBOARD\")"
},
v8 = {
  "kind": "Literal",
  "name": "first",
  "value": 5
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPoints",
  "storageKey": null
},
v10 = {
  "alias": "rankingUsers",
  "args": [
    (v8/*: any*/)
  ],
  "concreteType": "RankingUserConnection",
  "kind": "LinkedField",
  "name": "users",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RankingUserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RankingUser",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v9/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "users(first:5)"
},
v11 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": "TOTAL_POINTS_CURRENT_MONTH"
},
v12 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v13 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v14 = [
  {
    "kind": "Variable",
    "name": "club",
    "variableName": "slug"
  }
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "signedUrl",
    "storageKey": null
  },
  (v4/*: any*/)
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "ImageFile",
  "kind": "LinkedField",
  "name": "photo",
  "plural": false,
  "selections": (v16/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarFallback",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v20 = {
  "kind": "Literal",
  "name": "filterBy",
  "value": "UPCOMING"
},
v21 = {
  "kind": "Literal",
  "name": "orderBy",
  "value": "CHRONOLOGICAL"
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startDate",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endDate",
  "storageKey": null
},
v25 = [
  (v12/*: any*/),
  (v8/*: any*/),
  (v13/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "eventosQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubRanking",
            "kind": "LinkedField",
            "name": "ranking",
            "plural": false,
            "selections": [
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "portals_club"
          },
          {
            "args": [
              (v11/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "sidebarPreview"
          },
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "eventosFeedFragment"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "args": (v14/*: any*/),
            "kind": "FragmentSpread",
            "name": "portals_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "eventosQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubRanking",
            "kind": "LinkedField",
            "name": "ranking",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "order",
                    "value": "DESC"
                  },
                  (v11/*: any*/)
                ],
                "concreteType": "RankingUserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RankingUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RankingUser",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v17/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "username",
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPointsCurrentMonth",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPointsLast3Months",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "totalPointsLastMonth",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "users(first:5,order:\"DESC\",orderBy:\"TOTAL_POINTS_CURRENT_MONTH\")"
              }
            ],
            "storageKey": null
          },
          {
            "alias": "nextEvents",
            "args": [
              (v20/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              (v21/*: any*/)
            ],
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "events",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "events(filterBy:\"UPCOMING\",first:1,orderBy:\"CHRONOLOGICAL\")"
          },
          {
            "alias": null,
            "args": [
              (v20/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 3
              },
              (v21/*: any*/)
            ],
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "events",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": "events(filterBy:\"UPCOMING\",first:3,orderBy:\"CHRONOLOGICAL\")"
          },
          {
            "alias": null,
            "args": (v25/*: any*/),
            "concreteType": "MonthEventsConnection",
            "kind": "LinkedField",
            "name": "eventsByMonth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MonthEventsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MonthEvents",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Event",
                        "kind": "LinkedField",
                        "name": "events",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v23/*: any*/),
                          (v22/*: any*/),
                          (v5/*: any*/),
                          (v24/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "eventUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timezone",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "attendeeCount",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageFile",
                            "kind": "LinkedField",
                            "name": "coverPhoto",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Attendee",
                            "kind": "LinkedField",
                            "name": "attendee",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "status",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "host",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v26/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v25/*: any*/),
            "filters": [
              "orderBy",
              "filter"
            ],
            "handle": "connection",
            "key": "eventosFeedFragment__eventsByMonth",
            "kind": "LinkedHandle",
            "name": "eventsByMonth"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v14/*: any*/),
            "concreteType": "CompletedClass",
            "kind": "LinkedField",
            "name": "lastCompletedClass",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "courseClass",
                "plural": false,
                "selections": [
                  (v26/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "nextClass",
                        "plural": false,
                        "selections": [
                          (v26/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isCourseClass"
                          },
                          (v4/*: any*/),
                          (v27/*: any*/),
                          (v28/*: any*/),
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CourseSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Course",
                            "kind": "LinkedField",
                            "name": "course",
                            "plural": false,
                            "selections": [
                              (v27/*: any*/),
                              (v5/*: any*/),
                              (v28/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ImageFile",
                                "kind": "LinkedField",
                                "name": "landscapeImage",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ImageFile",
                                "kind": "LinkedField",
                                "name": "portraitImage",
                                "plural": false,
                                "selections": (v16/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CourseCategory",
                                "kind": "LinkedField",
                                "name": "category",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "orientation",
                                    "storageKey": null
                                  },
                                  (v28/*: any*/),
                                  (v4/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "CourseContent",
                    "abstractKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f613f21d8be3cd52e7b569c978e3febd",
    "id": null,
    "metadata": {},
    "name": "eventosQuery",
    "operationKind": "query",
    "text": "query eventosQuery(\n  $slug: String!\n  $orderBy: EventFeedOrdering!\n  $filter: EventFilter!\n) {\n  club(slug: $slug) {\n    id\n    permissions {\n      slug\n    }\n    leaderboard: configuration(key: \"LEADERBOARD\")\n    ranking {\n      rankingUsers: users(first: 5) {\n        edges {\n          node {\n            totalPoints\n          }\n        }\n      }\n    }\n    ...portals_club\n    ...sidebarPreview_2VzDD3\n    ...eventosFeedFragment_2Awgb3\n  }\n  user {\n    ...portals_user_3NTTF8\n    id\n  }\n}\n\nfragment eventCard on Event {\n  id\n  title\n  slug\n  startDate\n  endDate\n  eventUrl\n  timezone\n  attendeeCount\n  address\n  type\n  coverPhoto {\n    signedUrl\n    id\n  }\n  attendee {\n    status\n  }\n  host {\n    displayName\n    photo {\n      signedUrl\n      id\n    }\n    avatarFallback\n    id\n  }\n}\n\nfragment eventosFeedFragment_2Awgb3 on Club {\n  eventsByMonth(orderBy: $orderBy, filter: $filter, first: 5) {\n    edges {\n      node {\n        title\n        ...eventosMonthTimeline_events\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n  id\n}\n\nfragment eventosMonthTimeline_events on MonthEvents {\n  events {\n    id\n    startDate\n    ...eventCard\n  }\n}\n\nfragment portals_club on Club {\n  nextEvents: events(orderBy: CHRONOLOGICAL, filterBy: UPCOMING, first: 1) {\n    edges {\n      node {\n        id\n        ...portals_eventPortal\n      }\n    }\n  }\n}\n\nfragment portals_coursePortal on CourseClass {\n  __isCourseClass: __typename\n  id\n  name\n  active\n  slug\n  section {\n    active\n    id\n  }\n  course {\n    name\n    slug\n    active\n    landscapeImage {\n      signedUrl\n      id\n    }\n    portraitImage {\n      signedUrl\n      id\n    }\n    category {\n      orientation\n      active\n      id\n    }\n    id\n  }\n}\n\nfragment portals_eventPortal on Event {\n  id\n  title\n  startDate\n  endDate\n  slug\n}\n\nfragment portals_user_3NTTF8 on User {\n  lastCompletedClass(club: $slug) {\n    id\n    courseClass {\n      __typename\n      ... on CourseContent {\n        nextClass {\n          __typename\n          ...portals_coursePortal\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment sidebarPreviewEvents on Club {\n  events(orderBy: CHRONOLOGICAL, filterBy: UPCOMING, first: 3) {\n    edges {\n      node {\n        id\n        slug\n        title\n        startDate\n        endDate\n      }\n      cursor\n    }\n  }\n}\n\nfragment sidebarPreviewLeaderboard_2VzDD3 on Club {\n  ranking {\n    users(first: 5, orderBy: TOTAL_POINTS_CURRENT_MONTH, order: DESC) {\n      edges {\n        node {\n          user {\n            displayName\n            photo {\n              signedUrl\n              id\n            }\n            username\n            avatarFallback\n            id\n          }\n          totalPoints\n          totalPointsCurrentMonth\n          totalPointsLast3Months\n          totalPointsLastMonth\n        }\n        cursor\n      }\n    }\n  }\n  id\n}\n\nfragment sidebarPreview_2VzDD3 on Club {\n  ...sidebarPreviewEvents\n  ...sidebarPreviewLeaderboard_2VzDD3\n  leaderboard: configuration(key: \"LEADERBOARD\")\n  events(orderBy: CHRONOLOGICAL, filterBy: UPCOMING, first: 3) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  ranking {\n    rankingUsers: users(first: 5) {\n      edges {\n        node {\n          totalPoints\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "646259371350706ece9d1b634c7e3f98";

export default node;
